import { Button, Col, Form, Input, Row, Select } from '@sinohealth/butterfly-ui-components/lib';
import React from 'react';

const SearchForm: React.FC = (props: any = {}) => {
  const CateFee = [
    { label: '材料费', value: '材料费' },
    { label: '床位费', value: '床位费' },
    { label: '放射费', value: '放射费' },
    { label: '化验费', value: '化验费' },
    { label: '检查费', value: '检查费' },
    { label: '麻醉费', value: '麻醉费' },
    { label: '手术费', value: '手术费' },
    { label: '输血费', value: '输血费' },
    { label: '输氧费', value: '输氧费' },
    { label: '特殊检查费', value: '特殊检查费' },
    { label: '特殊治疗费', value: '特殊治疗费' },
    { label: '治疗费', value: '治疗费' },
    { label: '其他', value: '其他' },
  ];

  return (
    <Form labelAlign="left" colon={false} {...props}>
      <Row gutter={[120, 24]}>
        <Col span={6} style={{ paddingRight: 0 }}>
          <Form.Item name="medicareCode" label="医保项目编码：">
            <Input placeholder="请输入医保项目编码" />
          </Form.Item>
        </Col>
        <Col span={6} style={{ paddingRight: 0 }}>
          <Form.Item name="name" label="医保项目名称：">
            <Input placeholder="请输入医保项目名称" />
          </Form.Item>
        </Col>
        <Col span={6} style={{ paddingRight: 0 }}>
          <Form.Item name="feeCategory" label="统计类别：">
            <Select
              mode="multiple"
              allowClear
              maxTagCount="responsive"
              style={{ width: '100%' }}
              placeholder="请选择统计类别"
              options={CateFee}
            />
          </Form.Item>
        </Col>
        <Col span={6} style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              props.form.resetFields();
              props.form.submit();
            }}
          >
            重置
          </Button>
          &nbsp; &nbsp;
          <Button type="primary" htmlType="submit">
            查询
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchForm;
